import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LayoutAuth from "../../components/layoutAuth";
import { notificationsService } from "../../services/notifications";
import { getParameterByName } from "../../utils/urls";

const Unsubscribe = () => {
  const [profileHash] = useState(() => getParameterByName("profile_hash"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (!profileHash) {
      setError("Missing profile_hash in url");
      return;
    }

    setLoading(true);
    notificationsService.unsubscribeByHash(
      profileHash,
      () => {
        setLoading(false);
        setSuccess("You've been unsubscribed from all MoonScroll emails.");
      },
      (err) => {
        setLoading(false);
        const message = err?.response?.data?.error || "Could not unsubscribe from emails.";
        setError(message);
      }
    );
  }, [profileHash]);

  return (
    <LayoutAuth title="Email unsubscribe" subtitle="" compact>
      {loading && (
        <p className="text-sm text-theme-text opacity-80">Unsubscribing...</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      {success && (
        <div className="space-y-4">
          <p className="text-sm text-theme-text">{success}</p>
          <p className="text-sm text-theme-text opacity-80">
            You can re-enable emails in your{" "}
            <Link to="/account/notifications/" className="text-theme-primary hover:underline">
              notification settings
            </Link>
            {" "}after signing in.
          </p>
        </div>
      )}
      {!loading && !success && !error && (
        <p className="text-sm text-theme-text opacity-80">Processing...</p>
      )}
      <div className="mt-6 text-sm">
        <Link to="/login/" className="text-theme-primary hover:underline font-semibold">
          Sign in to your account
        </Link>
      </div>
    </LayoutAuth>
  );
};

export default Unsubscribe;
